import React from "react";
import { brands } from "../mock";

export default function Brands() {
  const doubled = [...brands.list, ...brands.list];
  return (
    <section className="relative overflow-hidden border-y border-white/10 bg-black/20 py-20">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="reveal flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mono-label text-xs text-[var(--crtr-yellow)]">{brands.kicker}</span>
            <h2 className="font-display mt-3 text-5xl text-white sm:text-6xl">{brands.title}<span className="text-[var(--crtr-yellow)]">))</span></h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/50">{brands.note}</p>
        </div>
      </div>

      <div className="relative mt-12 flex overflow-hidden">
        <div className="marquee-track flex w-max shrink-0 items-center">
          {doubled.map((b, i) => (
            <span key={i} className="font-heavy mx-8 whitespace-nowrap text-3xl uppercase text-white/25 transition-colors hover:text-[var(--crtr-yellow)] md:text-5xl">
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
